import paths from 'constants/paths';
const { basePath } = paths;
import { Article as ArticleType } from 'data/SingleArticle/types';

type articleJsonProps = {
  article: ArticleType;
};

export const ArticleJsonLd = ({ article }: articleJsonProps) => {
  const headline = article.title;
  const authorName = article?.author?.[0]?.name;
  const articleCategoryForParsely = (
    article.categories.find((category) => category.parentCategory?.slug) ||
    article.categories[0]
  ).categoryName;
  const parselyKeywords: string[] = [
    articleCategoryForParsely,
    ...article.personas,
    ...article.integrationCategories,
    ...article.integrationsMentioned,
    ...article.tags,
    ...(article.primaryIntegration ? [article.primaryIntegration] : []),
  ];

  const jsonLd = {
    '@context': 'http://schema.org',
    '@type': 'Article',
    headline,
    image: [article.image.url],
    dateModified: article.editorialLastPublishedDateComputed,
    datePublished: article.editorialOriginalPublishDate,
    author: {
      '@type': 'Person',
      name: authorName,
    },
    description: article.shortDescription,
    articleSection: articleCategoryForParsely,
    keywords: parselyKeywords,
    mainEntityOfPage: `https://zapier.com${basePath}/${article.slug}`,
    publisher: {
      '@type': 'Organization',
      name: 'Zapier',
      legalName: 'Zapier Inc',
      url: 'https://zapier.com',
      logo: {
        '@type': 'ImageObject',
        url: 'https://zapier.com/brand/assets/images/logos/zapier-logo.png',
      },
      foundingDate: '2011',
      founders: [
        {
          '@type': 'Person',
          name: 'Bryan Helmig',
        },
        {
          '@type': 'Person',
          name: 'Wade Foster',
        },
        {
          '@type': 'Person',
          name: 'Mike Knoop',
        },
      ],
      address: {
        '@type': 'PostalAddress',
        streetAddress: '548 Market St. #62411',
        addressLocality: 'San Francisco',
        addressRegion: 'CA',
        postalCode: '94104',
        addressCountry: 'USA',
      },
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer support',
        url: 'https://zapier.com/help/',
      },
      sameAs: [
        'http://www.facebook.com/ZapierApp',
        'http://www.linkedin.com/company/zapier/',
        'https://twitter.com/zapier',
        'http://www.youtube.com/user/ZapierApp/videos',
      ],
    },
    name: headline,
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
};
